export const seo = {
  methods: {
    getOgTitle(prefix) {
      const hasOgTitle = this.$te(`${prefix}.ogTitle`, this.$i18n.locale);
      if (!hasOgTitle) {
        return this.$t(`${prefix}.title`).split(/\s[\x7c\u2502]\s/)[0];
      }
      return this.$t(`${prefix}.ogTitle`);
    },
    getOgImage(key) {
      const hasOgImage = this.$te(key, this.$i18n.locale);
      if (!hasOgImage) {
        return '';
      }
      return this.$t(key);
    },
    getTitle(key, params) {
      return `${this.$t(key, params)} | ${
        this.$domainRegion === 'sk'
          ? 'uLekára.sk'
          : this.$domainRegion === 'hu'
          ? 'soulody.hu'
          : 'uLékaře.cz'
      }`;
    }
  }
};
